import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import LinkButton from '../atoms/button/LinkButton';
import Textlink from '../atoms/link/Textlink';

const ModalWesterPoint = ({ open, onClose }) => {
  const westerPointFaqLink = 'https://wester.jr-odekake.net/service/ntaweb/';

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="captionModal"
      bodyClassName="cautionModalBody"
      overlayClassName="cautionModalOverlay"
      customHeader={() => (
        <div className="captionModalHeader">
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
    >
      <div className="westerPointCaption">
        <div className="westerPointCaptionText">
          代表者情報を入力後、「WESTERポイント」の入力画面が表示されます。<br />
          利用ポイント数を入力いただくことで、旅行代金より差引くことができます。
        </div>
        <div className="westerPointCaptionText">
          「WESTERポイント」についてのご質問はJR西日本へお問い合わせください。<br />
          <span className="westerPointCaptionBold">※お問い合わせの前にご確認ください※</span><br />
          お客様からよくあるご質問とその回答をFAQページでご用意しています。<br />
          <span className="westerPointCaptionBold">WESTERサービス・ポイント全般については<Textlink to={westerPointFaqLink} outgoing>こちら</Textlink>（※JR西日本の画面に遷移します。）</span><br />
          お急ぎの場合はWESTERサービス総合ダイヤル（JR西日本）にお電話ください。<br />
          （0570-00-8999 受付時間9:00〜19:00）
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: 25 }}>
        <LinkButton buttonType="navigateMin" onClick={onClose}>閉じる</LinkButton>
      </div>
    </Modal>
  );
};

ModalWesterPoint.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalWesterPoint;